export default {
  init () {
    let that = this;
    $('.filter-select select').on('change', function () {
      let postType = $(this).val();
      let query = $('#searchForm input[name=s]').val();
      window.location.href = that.getActionUrl(postType, query);
    });
  },

  getActionUrl (postType, query) {
    let origin = window.location.origin;
    let params = '/?s='+query;
    if (postType != 'all') {
      params += '&post_type='+postType
    }
    return origin + params;
  },
}
